import { useState } from "react";
import { NavLink } from "react-router-dom";
import { api, ADMIN_STORAGE_KEY } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Lock } from "lucide-react";
import { ChangePasscode } from "@/components/ChangePasscode";

export const ADMIN_KEY = ADMIN_STORAGE_KEY;

export function AdminGate({ onUnlock }) {
  const [code, setCode] = useState("");
  const submit = async () => {
    try {
      const { data } = await api.post("/admin/session", null, { headers: { "X-Admin-Key": code } });
      sessionStorage.setItem(ADMIN_KEY, data.token);
      onUnlock(data.token);
    } catch (e) {
      const d = e?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "That passcode is not correct.");
    }
  };
  return (
    <div className="max-w-sm mx-auto bg-card border border-border rounded-3xl p-8 text-center">
      <Lock className="w-8 h-8 text-gold mx-auto" />
      <h2 className="font-serif text-2xl font-600 text-ink mt-3">Ministry Admin</h2>
      <p className="text-sm text-ink/60 mt-2">Enter the admin passcode to continue.</p>
      <Input data-testid="maps-admin-passcode" type="password" value={code} onChange={(e) => setCode(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && submit()} className="mt-5 h-12 rounded-full" placeholder="Passcode" />
      <Button data-testid="maps-admin-unlock" onClick={submit} className="mt-3 w-full h-12 rounded-full bg-gold text-ink hover:bg-ink hover:text-parchment font-700">Unlock</Button>
    </div>
  );
}

export const AdminSwitch = () => (
  <div className="flex flex-wrap gap-2 mb-6" data-testid="admin-switch">
    {[["/bible-requests", "Bible Requests", "admin-switch-requests"], ["/contact-inbox", "Messages", "admin-switch-messages"], ["/maps-admin", "Map Library", "admin-switch-maps"]].map(([to, label, id]) => (
      <NavLink key={to} to={to} data-testid={id}
        className={({ isActive }) => `px-4 py-1.5 rounded-full text-sm font-600 border ${isActive ? "bg-ink text-parchment border-ink" : "border-border text-ink/70 hover:border-gold"}`}>
        {label}
      </NavLink>
    ))}
    <ChangePasscode />
  </div>
);
